module.exports = __webpack_public_path__ + "img/screen-gr.946890e0.png";